'use client'

import { useContext } from 'react'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import { LayoutContext } from 'providers/LayoutProvider'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { mainProductConfig } from 'constants/mainProductConfig'
import { isExternal } from 'utils/conversions'
import classNames from 'classnames'

export function HyperLinkV2({ node, children, classNameOverride, variantClass, ...props }) {
  const currentURL = useCurrentUrl()
  const { state: { siteEnv } = {} } = useContext(LayoutContext)
  const linkId = node?.content[0]?.value
  const url = node?.data?.uri

  return (
    <AchieveLink
      track={{
        list_name: 'Inline Link',
        click_id: linkId,
        click_text: `${mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']}| ${linkId}`,
        click_type: 'Button Click',
        click_position: '0',
        nav_link_section: 'CTA Card - In-Content',
        track_event: 'page_nav_click',
        event_action: 'button_click',
        event_type: 'button_click',
      }}
      className={classNames(variantClass, classNameOverride)}
      data-testid={`Link-${url}-${linkId}`}
      href={url}
      target={isExternal(url, currentURL) ? '_blank' : '_self'}
      {...props}
      component="a"
    >
      {children[0] || children}
    </AchieveLink>
  )
}
